import { render, staticRenderFns } from "./EditAnswerModal.vue?vue&type=template&id=4847578e&scoped=true&"
import script from "./EditAnswerModal.vue?vue&type=script&lang=js&"
export * from "./EditAnswerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4847578e",
  null
  
)

export default component.exports